module.exports = __webpack_public_path__ + "img/percentPressed.a83791ca.png";